import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { procedureConfig } from './procedureConfig';
import { createProcedureValidation } from './procedureValidation';

const { config: initializedConfig } = initializeModule(
  procedureConfig,
  createProcedureValidation
);

const ProceduresPage = createModulePage(initializedConfig, {
  displayName: 'ProceduresPage',
  description: 'Procedure Management — same backend as Documents, scoped to procedure types',
});

export default ProceduresPage;
